<template>
  <div>
    <az-container>
      <div class="cabecalho">
        <div>
          <az-title/>
        </div>
        <div>
          <az-search slot="simpleSearch" @simple-search="buscaSimples" :filter="filtros"
                     @remove-filter="removerFiltro"
                     :simple-search-placeholder="placeholderPesquisa">
          </az-search>
        </div>
      </div>
      <div v-if="temLicitacaoLeilao" class="mt-4 px-4">
        <span class="font-weight-bold primary--text">Leilões Abertos</span>
        <v-progress-circular
            v-if="loadingImage"
            indeterminate
            color="primary"
            class="ma-2"
        />
        <az-thumbnails-bar
            v-else
            :imagens="imagensFormatadas"
            :thumbnail-width="180"
            :thumbnail-height="120"
            :centralizar-imagens="false"
            :showArrows="false"
            theme="light"
            @select="acessarDetalhesLote"
        />
      </div>
    </az-container>
    <todas-licitacoes-tabela class="listagem-compras" :itens="itens"
                                  :paginas="paginas"
                                  :total-itens="totalItens"
                                  :paginacao="paginacao"
                                  @paginar="paginar"
                                  @acessar="acessar"
                                  @acessarLicitacaoSgc="acessarLicitacaoSgc"
                                  @baixarAta="baixarAta"/>
  </div>
</template>
<script>
import {actionTypes} from '@/core/constants'
import TodasLicitacoesTabela from './LicitacoesDisponiveisTabela'
import AzThumbnailsBar from '@/views/components/AzThumbnailsBar'

export default {
    name: 'ConsultaDeLicitacoes',
    components: {TodasLicitacoesTabela, AzThumbnailsBar},
    data(){
        return{
            itens:[],
            paginas: 0,
            totalItens: 10,
            paginacao: {
                page: 1,
                rowsPerPage: 10,
            },
            filtros: {
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            },
            imagens: [],
            loadingImage: false,
            cacheImagemPorLicitacaoId: {}
        }
    },
    computed: {
        placeholderPesquisa() {
            return 'Busque por: Nº Processo, Nº Edital, Objeto ou Órgão'
        },
        licitacoesLeilao() {
            return this.itens.filter(item => item.modalidade === 'LEILÃO ELETRÔNICO')
        },
        temLicitacaoLeilao() {
            return this.licitacoesLeilao.length > 0
        },
        imagensFormatadas() {
            return this.imagens.map(imagem => ({
                ...imagem,
                src: this.resolverSrcImagem(imagem.base64)
            }))
        }

    },
    methods:{
        async buscar() {
            const params = {
                filtros: this.filtros,
                paginacao: this.paginacao
            }
            params.paginacao.size = params.paginacao.rowsPerPage
            const resultado = await this.$store.dispatch(actionTypes.BUSCAR_LICITACOES_PUBLICAS, params)
            this.itens = resultado.items
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            await this.buscarImagens()

        },
        async buscaSimples(valor){
            if(valor) {
                this.filtros.objeto.value = valor
                this.filtros.conteudo = valor
            }
            await this.buscar()
        },
        async baixarAta(id){
            await this.$store.dispatch(actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_LICITACAO, id)
        },
        acessar(licitacao){
            if (licitacao.linkAcessoExterno === null || licitacao.linkAcessoExterno === '') {
                let id = licitacao.id
                if (licitacao.modalidade === 'CREDENCIAMENTO') {
                    this.$router.push({name: 'credenciamentoVisualizacaoDadosGerais', params: {id}})
                } else {
                    this.$router.push({name: 'licitacaoVisualizacaoDadosGerais', params: {id}})
                }
            } else {
                window.open(licitacao.linkAcessoExterno, '_blank')
            }
        },
        acessarLicitacaoSgc(){
            const urlExecucao = 'licitacao/#/licitacoes'
            const url = `${window.location.protocol}//${window.location.hostname}/${urlExecucao}`
            window.open(url, '_blank')
        },
        paginar(paginacao) {
            this.paginacao = paginacao
            this.buscar()
        },
        removerFiltro(propriedade) {
            if (this.filtros && this.filtros.hasOwnProperty(propriedade)) {
                this.filtros[propriedade].value = this.filtros[propriedade].default
            }
            this.filtros.conteudo = ''
            this.buscar()
        },
        async atualizaDados(){
            this.desabilitarLoadingGlobal()
            await this.buscar()
            this.habilitarLoadingGlobal()
        },
        async buscarImagens() {
            this.imagens = []

            if (this.temLicitacaoLeilao) {
                this.loadingImage = true
                try {
                    for (const licitacao of this.licitacoesLeilao) {

                        const cacheImagensLeilao = this.cacheImagemPorLicitacaoId[licitacao.id]
                        if (cacheImagensLeilao && cacheImagensLeilao.length) {
                            this.imagens.push(...cacheImagensLeilao)
                            continue
                        }

                        const lista = await this.$store.dispatch(actionTypes.BUSCAR_IMAGENS_LOTE_LICITACAO, {licitacaoId: licitacao.id})

                        const imagensArray = Array.isArray(lista) ? lista : []
                        this.$set(this.cacheImagemPorLicitacaoId, licitacao.id, imagensArray)
                        this.imagens.push(...imagensArray)
                    }
                } catch (error) {
                    this.imagens = []
                } finally {
                    this.loadingImage = false
                }
            }
        },
        resolverSrcImagem(base64) {
            if (!base64) return ''
            return `data:image/jpeg;base64,${base64}`
        },
        acessarDetalhesLote(imagem) {
            this.$router.push({
                name: 'licitacaoVisualizacaoDetalhesLote',
                params: { id: imagem.licitacaoId },
                query: { loteId: imagem.loteId }
            })
        },
    },
}
</script>
<style lang="stylus">
.az-toolbar
  background-color transparent
  border none

.cabecalho
  padding-inline: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

body
  background-color white
</style>
